import React, { useEffect, useState, useRef } from "react";
import * as config from "../../config.js";
import { useSelector } from "react-redux";

import styled from "styled-components";
import { colors } from "../../utils/colors";
import sendImage from "../../assets/img/arrow-circle-up.png";
import BouncingDots from "components/BouncingDots";
import CloseButton from "components/CloseButton";

const ChatWrapper = styled.div`
  min-height: 500px;
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;
`;

const ChatInputWrapper = styled.div`
  height: 34px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 50px;
  border: 1px solid #e5e5e5;
  background-color: #f5f5f5;
  outline: none;
`;

const ChatInput = styled.textarea`
  color: black;
  height: 20px;
  width: 100%;
  padding-left: 10px;
  padding-right: 45px;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  resize: none;
  border: none;
  background: none;
  outline: none;
  padding-top: 0px;
  padding-bottom: 0px;

  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

const SendIcon = styled.div`
  position: absolute;
  right: 20px;
  bottom: 10px;
  width: 26px;
  height: 26px;
  background: transparent url(${sendImage}) no-repeat center center;
  background-size: 26px 26px;
  cursor: pointer;
`;

const ChatBubbleWrapper = styled.div`
  width: 100%;
`;

const UserChatBubble = styled.div`
  display: inline-block;
  margin-bottom: 20px;
  background-color: ${colors().lightAbyss};
  padding-top: 5px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
  border-radius: 20px;
  align-self: flex-end;
  color: ${colors().darkestAbyss};
  font-size: 14px;
  text-align: left;
`;

const LiveEventChatSession = ({
  display,
  messages,
  ws,
  event_id,
  user_id,
  height,
  ended = false,
  relevanceThreshold = 0,
  promoteContent = () => {},
}) => {
  const { token } = useSelector((state) => state.users);
  const [message, setMessage] = useState("");
  const [messageBubbles, setMessageBubbles] = useState([]);
  const chatWrapperRef = useRef(null);

  useEffect(() => {
    setMessageBubbles(
      messages
        .sort((a, b) => a.created_at < b.created_at)
        .map((message) => {
          return (
            <ChatBubble
              key={message.id}
              type={message.message_type}
              message_id={message.public_id}
              message={message.message}
              user={message.user}
              relevance={message.relevance}
            />
          );
        })
    );
  }, [messages]);

  useEffect(() => {
    if (chatWrapperRef.current) {
      chatWrapperRef.current.scrollTop = chatWrapperRef.current.scrollHeight;
    }
  }, [messageBubbles]);

  const sendMessage = () => {
    console.log("!!! SEND MESSAGE: ", event_id, user_id, message);
    if (ws.current) {
      console.log("!!! SEND EVENT MESSAGE");
      ws.current.emit("event-message", {
        token: token,
        event_id: event_id,
        message: message,
        user_id: user_id,
      });
      setMessageBubbles([
        ...messageBubbles,
        <ChatBubble type="user" message={message} user={{ nickname: "You" }} />,
      ]);
      setMessage("");
    }
  };

  const ChatBubble = ({
    type = "",
    message = "",
    message_id = null,
    relevance = 0,
    user = null,
  }) => {
    if (!message) {
      return;
    }

    return (
      <ChatBubbleWrapper
        style={{
          textAlign: "left",
          flexDirection: "row",
          display: "flex",
        }}
      >
        <div
          style={{
            height: "30px",
            width: "30px",
            borderRadius: "50%",
            backgroundColor: "#f9d8b5",
            marginRight: "10px",
            marginTop: "10px",
            position: "relative",
            flexShrink: 0,
          }}
        >
          {user?.icon_background ? (
            <img
              src={require(`../../assets/live-event-icons/${user.icon_background}.png`)}
              alt="User Avatar"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
              }}
            />
          ) : null}
          {user?.icon_name ? (
            <img
              src={require(`../../assets/live-event-icons/${user.icon_name}.png`)}
              alt="User Avatar"
              style={{
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                position: "absolute",
                top: "5px",
                left: "5px",
              }}
            />
          ) : null}
        </div>
        <UserChatBubble>
          <div style={{ fontWeight: "700" }}>
            {user?.nickname.replace(" null", "")}
          </div>
          <div style={{ marginTop: "-8px", fontStyle: "italic" }}>
            {type}
            {type === "comment" ||
            type === "statement" ||
            relevance < relevanceThreshold ? (
              <span
                onClick={() => {
                  promoteContent(message_id, relevance);
                }}
                onMouseOver={(e) =>
                  (e.target.style.textDecoration = "underline")
                }
                onMouseOut={(e) => (e.target.style.textDecoration = "none")}
                style={{
                  color: "#333",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
              >
                {" "}
                (promote)
              </span>
            ) : null}
          </div>
          {message.replace(/\n/, "<br>")}
        </UserChatBubble>
      </ChatBubbleWrapper>
    );
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (!e.shiftKey) {
        e.preventDefault();
        sendMessage();
      } else {
        setMessage(message + "\n");
      }
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: height,
        position: "relative",
        display: display ? "block" : "none",
      }}
    >
      <div
        className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none"
        style={{ width: "100%", height: "100%" }}
      >
        {/*body*/}
        <div style={{ height: "calc(100% - 40px)" }}>
          <div
            ref={chatWrapperRef}
            className="my-4 text-blueGray-500 text-lg leading-relaxed overflow-auto flex"
            style={{ height: "100%" }}
          >
            <ChatWrapper>{messageBubbles}</ChatWrapper>
          </div>
        </div>
        {/*footer*/}
        {!ended && (
          <div style={{ height: "40px" }}>
            <ChatInputWrapper>
              <ChatInput
                type="textarea"
                value={message}
                onKeyPress={handleKeyPress}
                onChange={(e) => setMessage(e.target.value)}
              ></ChatInput>
              <SendIcon
                style={{ display: message.length > 0 ? "block" : "none" }}
                onClick={sendMessage}
              />
            </ChatInputWrapper>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveEventChatSession;
